import { format, unwrapFunctionStore } from 'svelte-i18n';

import { GLOBAL_DRIVER_OBJECT } from '@client/enums';

const $format = unwrapFunctionStore(format);

export const layoutControls = {
  element: '#content > div.page.manage-campaigns > div.page-content > div.toolbar > div.filters > div.display-options',
  popover: {
    title: 'Switch Layouts',
    description:
      'Switch up your view! Use the <code><i class="os-icon-grid"></i></code> button for a card view or the <code><i class="os-icon-menu"></i></code> button for a list view.',
    side: 'bottom',
    align: 'center',
    onPrevClick: () => {
      const exportBtn = document.querySelector('#export-dropdown > button');

      if (exportBtn) {
        exportBtn.click();

        GLOBAL_DRIVER_OBJECT.movePrevious();
      }
    }
  }
};
